export default {
  SELECT({commit}, payload) {
    commit('SELECT', payload)
  },
  LAUNCH_CONFIG({commit}) {
    commit('LAUNCH_CONFIG');
  },
  LAUNCH_STOCK({commit}) {
    commit('LAUNCH_STOCK');
  },
  LAUNCH_PRICE({commit}) {
    commit('LAUNCH_PRICE');
  },
  COLOR_FILTER_CODE({commit}, payload) {
    commit('COLOR_FILTER_CODE', payload);
  },
  RESET_PRODUCT_CONFIG({commit}, payload) {
    commit('RESET_PRODUCT_CONFIG', payload);
  },
  RESET_PRODUCT_PAGE({commit}) {
    commit('RESET_PRODUCT_PAGE');
  },
  SET({commit}, payload) {
    commit('SET', payload)
  },
}